import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import { UpdateProgressContext } from "./UpdateProgressStore";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { updateInProgressSliceActions } from "./updateProgressSlice";
import {
    NOTIFY_UPDATE_STATE_UPDATE,
    REQUEST_UPDATE_STATE,
    RESPOND_UPDATE_STATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/updates/updateMsgs";
import UpdateProgressStore from "./UpdateProgressStore";
import { VideoEngineUpdateState } from "userful-chronos-app-common-js/dist/models/config/packageUpdates";

interface IProps {
    children: ReactNode;
}

registerMsgHandler(RESPOND_UPDATE_STATE, (data) => {
    console.debug("RESPOND_UPDATE_STATE");
    const dataJSONItem = JSON.parse(data) as VideoEngineUpdateState;
    UpdateProgressStore.dispatch(updateInProgressSliceActions.setStatus(dataJSONItem));
});
registerMsgHandler(NOTIFY_UPDATE_STATE_UPDATE, (data) => {
    console.debug("NOTIFY_UPDATE_STATE_UPDATE");
    const dataJSONItem = JSON.parse(data) as VideoEngineUpdateState;
    UpdateProgressStore.dispatch(updateInProgressSliceActions.setStatus(dataJSONItem));
});

function UpdateProgressProvider(props: IProps) {
    useEffect(() => {
        getGlobalStates().eventBus &&
            getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_STATE, {
                value: getGlobalStates().systemID,
            });
    }, []);

    return (
        <Provider store={UpdateProgressStore} context={UpdateProgressContext}>
            {props.children}
        </Provider>
    );
}

export default UpdateProgressProvider;
